import { mutationTypes } from '@/core/constants'
import { FiltroUtils } from '@/core/utils'

export default {
	[mutationTypes.PEDIDO.DOCUMENTOS.LISTAGEM.SET_FILTRO](state, filtro) {
		state.filtro = filtro
	},

	[mutationTypes.PEDIDO.DOCUMENTOS.LISTAGEM.SET_PAGINACAO](state, paginacao) {
		state.paginacao = paginacao
	},

	[mutationTypes.PEDIDO.DOCUMENTOS.LISTAGEM.LIMPAR_FILTRO](state) {
		FiltroUtils.limparFiltroAvancado(state.filtro)
	},

	[mutationTypes.PEDIDO.DOCUMENTOS.LISTAGEM.RESETAR_PAGINA](state) {
		state.paginacao.page = 1
	},

	[mutationTypes.PEDIDO.DOCUMENTOS.CHECKBOX.SET_IS_SELECIONOU_TODOS_ITENS](state) {
		state.isSelecionouTodosItensDaListaDeDocumentosPedido = true
	},

	[mutationTypes.PEDIDO.DOCUMENTOS.CHECKBOX.DESFAZER_SELECAO_ITENS_LISTAGEM](state) {
		state.isSelecionouTodosItensDaListaDeDocumentosPedido = false
		state.documentosSelecionados = []
	},

	[mutationTypes.PEDIDO.DOCUMENTOS.CHECKBOX.DOCUMENTOS_SELECIONADOS](state, itens) {
		state.documentosSelecionados = itens
	},
}
